import cn from 'classnames';
import DataroomListItem from '../../../domain/DataroomListItem';
import { useTransactionTypeContext } from "../../../contexts/TransactionTypeContext";
import { IDataroomListItem } from "../../../domain/vo/DataroomListItem";
import styles from '../datarooms.module.scss';

interface IProps {
  cellProps: {
    row: IDataroomListItem,
    cellTitle?: React.ReactNode,
  },
  isDisabled: boolean,
}

const TransactionTypeCell = ({ cellProps: { row, cellTitle }, isDisabled }: IProps) => {
  const { collection } = useTransactionTypeContext();
  const isDataroomDisabled = DataroomListItem.isDataroomDisabled(row);
  const displayName = collection.find((item) => item.id === row.transactionTypeId)?.name || '-';

  return (
    <span className={ cn(
      styles.transactionType,
      { [styles.deactivatedDataroom]: isDataroomDisabled },
      { [styles.columnDisable]: isDisabled },
    ) }
    >
      <span className={ styles.mobileColName }>{ cellTitle }</span>
      { displayName }
    </span>
  );
};

export default TransactionTypeCell;
